var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-radio-list',_vm._g(_vm._b({attrs:{"values":_vm.yesOrNo,"title":_vm.title,"model":_vm.model,"disabled":_vm.disabled.all}},'w-radio-list',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }